import axios from 'axios'
const CancelToken = axios.CancelToken
let setPdfOptionsCancelFunction

export default {
  async setPdfOptions(pdfOptions) {
    const {
      quoteId,
      printContractorOnOrder,
      printContactInfoOnPdf,
      showVwpfsFinancePdf,
      showVwpfsPrivateLeasePdf,
      showVwpfsInsurancePdf,
      showVwpfsOperationalLeasePdf,
    } = pdfOptions

    if (!quoteId) {
      // no quoteId provided, can't save
      return null
    }

    //cancel previous call
    setPdfOptionsCancelFunction && setPdfOptionsCancelFunction()

    try {
      const response = await axios.post(
        `${quoteId}/PrintOptions`,
        {
          printContractorOnOrder,
          printContactInfoOnPdf,
          showVwpfsFinancePdf,
          showVwpfsPrivateLeasePdf,
          showVwpfsInsurancePdf,
          showVwpfsOperationalLeasePdf,
        },
        {
          cancelToken: new CancelToken((c) => {
            setPdfOptionsCancelFunction = c
          }),
        }
      )
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
